/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY2xtdGxrL2NvcmUvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9zcmMvYXBwL2NsbXRsay9jb3JlL2Zvb3Rlci9mb290ZXIuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/clmtlk/core/footer/footer.component.scss.shim.ngstyle.ts